module.exports = __webpack_public_path__ + "img/hr-tree-05-d-trunk.49a020fc.png";